"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _ClientSummary = _interopRequireDefault(require("./ClientSummary"));

require("../styles/_clients.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MAX_INITIAL_VISIBLE_CLIENTS = 6;
var MAX_LOAD_MORE_CLIENTS = 3;

var Clients = /*#__PURE__*/function (_Component) {
  _inherits(Clients, _Component);

  var _super = _createSuper(Clients);

  function Clients(props) {
    var _this;

    _classCallCheck(this, Clients);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      var items = _this.props.items;
      var visibleItems = _this.state.visibleItems;

      _this.setState({
        visibleItems: [].concat(_toConsumableArray(visibleItems), _toConsumableArray(items.slice(visibleItems.length, visibleItems.length + MAX_LOAD_MORE_CLIENTS)))
      });
    });

    var _items = props.items;
    _this.state = {
      visibleItems: _items ? _items.slice(0, MAX_INITIAL_VISIBLE_CLIENTS) : []
    };
    return _this;
  }

  _createClass(Clients, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.items && this.props.items) {
        this.setState({
          visibleItems: this.props.items.slice(0, MAX_INITIAL_VISIBLE_CLIENTS)
        });
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props$items = this.props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items;
      var suffix = "Client".concat(items.length === 1 ? '' : 's');
      return /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading3: true,
        noMargin: true,
        prefixIcon: "organisation"
      }, "".concat(suffix, " (").concat(items.length, ")"));
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var visibleItems = this.state.visibleItems;

      if (!visibleItems.length) {
        return /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
          rounded: true,
          className: "clients__body--empty"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
          placeholder: true,
          centered: true,
          noMargin: true
        }, 'This team hasn\'t been assigned to any clients yet'));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "clients__body"
      }, visibleItems.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_ClientSummary.default, _extends({}, item, {
          key: item.organisationId
        }));
      }));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var items = this.props.items;
      var visibleItems = this.state.visibleItems;
      return !items || visibleItems.length >= items.length ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "clients__footer"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Link, {
        onClick: this.loadMore,
        className: "clients__view-more"
      }, "View More"));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "clients"
      }, this.renderHeader(), this.renderItems(), this.renderFooter());
    }
  }]);

  return Clients;
}(_react.Component);

exports.default = Clients;

_defineProperty(Clients, "displayName", 'Clients');